import React, { useState } from "react";
import rejectedGif from "../assests/payment.gif";
import VoucherViewer from "./VoucherViewer";
function AdminREjectedVoucher(props) {
  const [open, setOpen] = useState(false);
  const [Id, setId] = useState(null);
  let selectedTheme=""
  return (
    <div
    //  className="w-[100%]  min-[689px]:w-[40%] min-h-[400px]  h-[65vh] min-[689px]:m-2 my-2 bg-[white] rounded-lg shadow-md shadow-gray-700 text-center "
     >
      <VoucherViewer
        close={() => {
          setOpen(!open);
        }}
        voucherId={Id}
        open={open}
      ></VoucherViewer>{" "}
      {/* <p
        className={` border-white  py-2 font-bold CARDHEADERCOLOR text-white  text-2xl md:text-3xl rounded-t-lg font-sans`}
      >
        Rejected Voucher
      </p>
      {props?.rejected?.length == 0 && (
        <>
          <div className="w-[100%] h-[calc(65vh-90px)] min-h-[calc(400px-70px)] text-black flex justify-center items-center flex-col">
            <img src={rejectedGif} className="h-[80px]" draggable={false}></img>
            <p className="font-bold">no Rejected Voucher </p>
          </div>
        </>
      )}
      {props?.rejected?.length > 0 && (
        <>
          <div className="w-[100%]">
            <div className="m-2 bg-white text-black flex  font-bold items-center border-b-2">
              <p className="w-[10%] px-1">V.no</p>
              <p className="w-[27%] px-1">Name</p>
              <p className="w-[25%] px-1">Trip</p>
              <p className="w-[23%] px-1">Date</p>
              <p className="w-[15%] px-1 text-center"></p>
            </div>
          </div>
          <div className="w-full h-[calc(40vh-70px)] min-h-[calc(400px-70px)] overflow-y-auto bg-gray-100 rounded-lg shadow-md">
            {props.rejected.map((current, index) => {
              return (
                <div
                  key={current.Voucher?.id}
                  className={`mx-2 my-1 py-1 px-2 flex items-center rounded-lg shadow-sm transition-all duration-200 ease-in-out ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-200"
                  }`}
                >
                  <p className="w-[10%] px-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    {current.Voucher?.id}
                  </p>
                  <p className="w-[27%] px-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    {current.user?.firstName + " " + current.user?.lastName}
                  </p>
                  <p className="w-[25%] px-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    {current?.Voucher?.tourLocation}
                  </p>
                  <p className="w-[23%] px-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    {current?.Voucher?.tourDate}
                  </p>
                  <div className="w-[15%] px-1 overflow-hidden whitespace-nowrap overflow-ellipsis">
                    <p
                      className="bg-blue-500 text-white font-bold text-center rounded hover:bg-blue-700 cursor-pointer transition-all duration-200 ease-in-out"
                      onClick={() => {
                        setOpen(true);
                        setId(current?.Voucher?.id);
                      }}
                    >
                      View
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )} */}
      {props?.rejected && (
        <section
          className={`${
            selectedTheme === "modern reeloid"
              ? "bg-black/40 backdrop-blur-lg "
              : "bg-[#2A3042] "
          } py-2  rounded-md m-4 mt-8`}
        >
          <div className="flex justify-between p-4 border-b-2">
            <p className="text-white text-[1.2rem] font-bold">Rejected Vouchers</p>
            <input
              placeholder="Search Voucher Here"
              className="px-2 rounded"
            ></input>
          </div>
          <div className="flex gap-6 flex-col xl:flex-row">
            <div
              className={` ${
                selectedTheme === "modern reeloid"
                  ? "bg-black/40 backdrop-blur-lg "
                  : "bg-[#2A3042] "
              } flex-1  rounded-md text-gray-200 max-md:overflow-auto py-2`}
            >
              <div className=" font-normal text-[.9rem] min-w-[740px]">
                <div className="font-semibold flex border-b pb-2 border-gray-500">
                  <div className="w-[100px] flex flex-shrink-0 items-center">
                    <p className="px-4">Id</p>
                  </div>
                  <div className="w-[180px] flex flex-shrink-0 items-center">
                    <p className="px-4">Name</p>
                  </div>
                  <div className="w-[100%] flex flex-shrink-1 min-w-[100px] mx-8">
                    <p className="p-2">Trip</p>
                  </div>
                  <div className="w-[180px] flex flex-shrink-0 items-center">
                    <p className="px-4">Date</p>
                  </div>
                  <div className="w-[240px] flex flex-shrink-0">
                    <p className="p-2">Status</p>
                  </div>
                </div>
                {props?.rejected?.length > 0 &&
                  props?.rejected?.map((current, index) => {
                    return (
                      <div
                        className="hover:cursor-pointer hover:bg-yellow-600 font-normal flex my-2 text-gray-200 border-b border-gray-500  shadow-lg hover:scale-95 hover:shadow-xl transition-transform duration-200"
                        onClick={() => {
                          setOpen(true);
                          setId(current?.Voucher?.id);
                        }}
                      >
                        <div className="w-[100px] px-2  flex-shrink-0">
                          <p className="p-2">{current?.Voucher?.id}</p>
                        </div>
                        <div className="w-[180px] flex flex-shrink-0 items-center">
                          <p className="px-4">{current?.user?.firstName}</p>
                        </div>
                        <div className="w-[100%]  flex-shrink-1 min-w-[100px] flex  items-center mx-8">
                          <p className="p-2">
                            {current?.Voucher?.tourLocation}
                          </p>
                        </div>{" "}
                        <div className="w-[180px] px-2  flex-shrink-0">
                          <p className="p-2">
                            {current?.Voucher?.tourDate || "-"}
                          </p>
                        </div>
                        <div className="w-[240px] flex flex-shrink-0">
                          <p className="p-2 text-wrap whitespace-normal break-words w-[100%]">
                            {current.statusType}
                          </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
}

export default AdminREjectedVoucher;
